// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { LAYOUT } from 'constant/layout.constant'
import { CONTACT_US_MODULE, CONTACT_US_URL } from 'constant/url.constant'

// UI
const { ContactUsIndex } = lazily(() => import('pages/webpage/contact-us'))

const contactUsRoutes: IRoute[] = [
  {
    path: CONTACT_US_URL.INDEX,
    component: ContactUsIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: CONTACT_US_MODULE,
      requireAuth: false,
      attrs: {
        label: 'contactUs.contactUs',
      },
    },
  },
]

export { contactUsRoutes }
